import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePermissions, type PermissionArea } from '@/hooks/usePermissions';
import { ShieldX, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PermissionRouteProps {
  children: React.ReactNode;
  requiredPermission: PermissionArea;
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({
  children,
  requiredPermission
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const hasAccess = hasPermission(requiredPermission);

  if (!hasAccess) {
    console.warn(`[PermissionRoute] Acesso negado à rota ${location.pathname} - requer permissão: ${requiredPermission}`);

    return (
      <div className="w-full h-[calc(100vh-64px)] flex items-center justify-center bg-neutral-900">
        <div className="max-w-md w-full mx-4">
          <div className="bg-neutral-800 border border-neutral-700 rounded-lg p-8 text-center">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-red-500/10 border border-red-500/20 rounded-full flex items-center justify-center">
                <ShieldX className="w-10 h-10 text-red-500" />
              </div>
            </div>

            <h1 className="text-2xl font-bold text-neutral-50 mb-3">
              Acesso Negado
            </h1>

            <p className="text-neutral-400 mb-2">
              Você não tem permissão para acessar esta página.
            </p>

            <p className="text-sm text-neutral-500 mb-8">
              Entre em contato com o administrador do sistema para solicitar acesso.
            </p>

            <div className="flex flex-col gap-3">
              <button
                onClick={() => navigate('/')}
                className="w-full bg-neutral-700 hover:bg-neutral-600 text-neutral-50 font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <ArrowLeft className="w-4 h-4" />
                Voltar ao Dashboard
              </button>

              <button
                onClick={() => navigate(-1)}
                className="w-full bg-transparent hover:bg-neutral-700/50 text-neutral-400 hover:text-neutral-50 font-medium py-3 px-4 rounded-lg transition-colors border border-neutral-700"
              >
                Voltar à página anterior
              </button>
            </div>

            <p className="mt-6 text-xs text-neutral-600">
              Permissão necessária: <span className="text-neutral-400 font-mono">{requiredPermission}</span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
